import { Injectable } from '@angular/core';

declare const XPayStationWidget: any;
const scriptSrc = 'https://cdn.xsolla.net/embed/paystation/1.0.2/widget.min.js';

@Injectable()
export class XPayStationWidgetService {
    eventTypes: any;

    constructor() {
        // load script
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = scriptSrc;
        script.onload = () => {
            Object.assign(this, XPayStationWidget);
        };

        document.getElementsByTagName('head')[0].appendChild(script);
    }

    init(options: any) {}
    open() {}

    on(eventName: string, callback: Function) {}
    off(eventName: string, callback: Function) {}
}
